module.exports = __webpack_public_path__ + "e425e0742e7cec7da973ee1c41c75061.png";